import React, { useState } from "react";
import { Link } from "react-router-dom";

function UploadJokesPage() {
  const [file, setFile] = useState(null);
  const [jokeType, setJokeType] = useState("kids");
  const [uploadStatus, setUploadStatus] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "text/csv") {
      setFile(selectedFile);
      setError("");
    } else {
      setError("Please upload a valid CSV file");
      setFile(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a CSV file first");
      return;
    }

    try {
      setUploadStatus("Processing...");

      const formData = new FormData();
      formData.append("file", file);
      formData.append("jokeType", jokeType);

      const response = await fetch("http://localhost:5001/api/upload-jokes", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setUploadStatus(data.message);
        setFile(null);
      } else {
        setError(data.error || "Error uploading jokes");
      }
    } catch (err) {
      setError(`Error uploading jokes: ${err.message}`);
      setUploadStatus("");
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="py-4 px-8 bg-white flex justify-start items-center border-b border-gray-200">
        <div className="text-[#23c55e] text-3xl font-bold">
          <Link to="/">YOO!</Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-8">
        <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            Upload Jokes
          </h2>

          <div className="mb-6">
            <label htmlFor="jokeType" className="block text-gray-700 mb-2">
              Joke Type
            </label>
            <select
              id="jokeType"
              value={jokeType}
              onChange={(e) => setJokeType(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            >
              <option value="kids">Kids</option>
              <option value="adult">Adult</option>
            </select>
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 mb-2">Upload CSV File</label>
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              className="w-full p-2 border border-gray-300 rounded"
            />
            <p className="text-sm text-gray-500 mt-1">
              CSV format: title, body, punchline (optional)
            </p>
          </div>

          {error && <div className="mb-4 text-red-500 text-sm">{error}</div>}

          {uploadStatus && (
            <div className="mb-4 text-green-500 text-sm">{uploadStatus}</div>
          )}

          <button
            onClick={handleUpload}
            disabled={!file}
            className={`w-full bg-[#23c55e] text-white py-3 rounded font-medium ${
              !file ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            Upload Jokes
          </button>
        </div>
      </main>
    </div>
  );
}

export default UploadJokesPage;
